// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3U8wT","select":"Header_select__1Ih3_","clinic":"Header_clinic__s1OQ0"};